import { createVNode as o, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RotateLeftOutlinedStandard.js";
import i from "../components/PfIcon.js";
const t = (e, r) => {
  const a = {
    ...e,
    ...r.attrs
  };
  return o(i, n(a, {
    icon: d
  }), null);
};
t.displayName = "RotateLeftOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
